module.exports = __webpack_public_path__ + "img/setSessuon.5c788112.svg";